module.exports = __webpack_public_path__ + "img/erweima.73ad0f33.jpg";